// @flow
import * as React from 'react';

import styles from './styles';

type Props = {
  searchParams: Object,
  verticalName: VerticalName,
  children: Function,
};

export default function FilterTagsList({
  children,
  searchParams,
  verticalName,
}: Props): React.Node {
  return (
    <ul className="filters-tag-list">
      {children(searchParams, verticalName)}
      <style jsx>{styles}</style>
    </ul>
  );
}



// WEBPACK FOOTER //
// ./app/common/FilterTags/list/index.js